import { useTranslation } from 'react-i18next';
import SectionTitle from './SectionTitle';
import { FaEnvelope, FaPhoneAlt, FaMapMarkerAlt } from 'react-icons/fa';
import { FaGithub, FaTwitter, FaLinkedinIn, FaInstagram } from 'react-icons/fa';

const Contact = ({ id }) => {
  const { t } = useTranslation();

  return (
    <section id={id} className="py-16 md:py-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto transition-colors duration-200" style={{backgroundColor: 'var(--muted)', color: 'var(--foreground)'}}>
      <SectionTitle
        title={t('contact.title')}
        coloredTitle={t('contact.coloredTitle')}
      />

      <div className="flex flex-col lg:flex-row gap-8 lg:gap-12">
        {/* Contact Info */}
        <div className="lg:w-1/2">
          <div className="max-w-lg mx-auto lg:mx-0">
            <h3 className="text-xl sm:text-2xl font-semibold mb-4 sm:mb-6" style={{color: 'var(--foreground)'}}>{t('contact.info.heading')}</h3>
            <p className="mb-6 sm:mb-8 text-sm sm:text-base" style={{color: 'var(--muted-foreground)'}}>
              {t('common.contact.placeholder')}
            </p>
            <div className="space-y-4 sm:space-y-6">
              <div className="flex items-start">
                <div className="flex-shrink-0 p-2 sm:p-3 rounded-full text-blue-500 mr-3 sm:mr-4" style={{backgroundColor: 'var(--accent)'}}>
                  <FaEnvelope className="text-lg sm:text-xl" />
                </div>
                <div>
                  <h4 className="font-medium" style={{color: 'var(--foreground)'}}>{t('common.labels.email')}</h4>
                  <p style={{color: 'var(--muted-foreground)'}}>ismail_coder@protonmail.com</p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="flex-shrink-0 p-2 sm:p-3 rounded-full text-purple-500 mr-3 sm:mr-4" style={{backgroundColor: 'var(--accent)'}}>
                  <FaPhoneAlt className="text-lg sm:text-xl" />
                </div>
                <div>
                  <h4 className="font-medium" style={{color: 'var(--foreground)'}}>{t('common.labels.phone')}</h4>
                  <p style={{color: 'var(--muted-foreground)'}}>+212 655779437</p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="flex-shrink-0 p-2 sm:p-3 rounded-full text-green-500 mr-3 sm:mr-4" style={{backgroundColor: 'var(--accent)'}}>
                  <FaMapMarkerAlt className="text-lg sm:text-xl" />
                </div>
                <div>
                  <h4 className="font-medium" style={{color: 'var(--foreground)'}}>{t('common.labels.location')}</h4>
                  <p style={{color: 'var(--muted-foreground)'}}>Tangier, Morocco</p>
                </div>
              </div>
            </div>
            <div className="mt-8 pt-6 border-t" style={{borderColor: 'var(--border)'}}>
              <h4 className="font-medium mb-4" style={{color: 'var(--foreground)'}}>{t('contact.info.followHeading')}</h4>
              <div className="flex flex-wrap gap-3 sm:gap-4">
                <a
                  href="https://github.com/ismailfreelance"
                  target="_blank"
                  rel="noreferrer"
                  className="w-9 h-9 sm:w-10 sm:h-10 rounded-full shadow-sm border flex items-center justify-center hover:bg-blue-500 hover:text-white hover:border-transparent transition-all duration-300"
                  style={{backgroundColor: 'var(--card)', color: 'var(--muted-foreground)', borderColor: 'var(--border)'}}
                  aria-label={t('common.social.github')}
                >
                  <FaGithub className="text-base sm:text-lg" />
                </a>
                <a
                  href="https://x.com/ismailfreelance"
                  target="_blank"
                  rel="noreferrer"
                  className="w-9 h-9 sm:w-10 sm:h-10 rounded-full shadow-sm border flex items-center justify-center hover:bg-blue-400 hover:text-white hover:border-transparent transition-all duration-300"
                  style={{backgroundColor: 'var(--card)', color: 'var(--muted-foreground)', borderColor: 'var(--border)'}}
                  aria-label={t('common.social.twitter')}
                >
                  <FaTwitter className="text-base sm:text-lg" />
                </a>
                <a
                  href="https://www.linkedin.com/in/ismail-dev"
                  target="_blank"
                  rel="noreferrer"
                  className="w-9 h-9 sm:w-10 sm:h-10 rounded-full shadow-sm border flex items-center justify-center hover:bg-blue-600 hover:text-white hover:border-transparent transition-all duration-300"
                  style={{backgroundColor: 'var(--card)', color: 'var(--muted-foreground)', borderColor: 'var(--border)'}}
                  aria-label={t('common.social.linkedin')}
                >
                  <FaLinkedinIn className="text-base sm:text-lg" />
                </a>
                <a
                  href="https://www.instagram.com/ismailfreelance/"
                  target="_blank"
                  rel="noreferrer"
                  className="w-9 h-9 sm:w-10 sm:h-10 rounded-full shadow-sm border flex items-center justify-center hover:bg-pink-600 hover:text-white hover:border-transparent transition-all duration-300"
                  style={{backgroundColor: 'var(--card)', color: 'var(--muted-foreground)', borderColor: 'var(--border)'}}
                  aria-label={t('common.social.instagram')}
                >
                  <FaInstagram className="text-base sm:text-lg" />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Contact Form */}
        <div className="md:w-1/2">
          <form
            action="https://formspree.io/f/xblkwvpv"
            method="POST"
            className="space-y-5 sm:space-y-6"
          >
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
              <div>
                <label htmlFor="name" className="block text-sm font-medium mb-1.5" style={{color: 'var(--foreground)'}}>{t('contact.form.labels.name')}</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  required
                  className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition duration-300"
                  style={{borderColor: 'var(--border)', backgroundColor: 'var(--input)', color: 'var(--foreground)'}}
                />
              </div>
            </div>
            <div>
              <label htmlFor="subject" className="block text-sm font-medium mb-1.5" style={{color: 'var(--foreground)'}}>{t('contact.form.labels.subject')}</label>
              <input
                type="text"
                id="subject"
                name="subject"
                className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition duration-300"
                style={{borderColor: 'var(--border)', backgroundColor: 'var(--input)', color: 'var(--foreground)'}}
              />
            </div>
            <div>
              <label htmlFor="message" className="block text-sm font-medium mb-1.5" style={{color: 'var(--foreground)'}}>{t('contact.form.labels.message')} <span className="text-red-500">{t('contact.form.message.required')}</span></label>
              <textarea
                id="message"
                name="message"
                rows="4"
                required
                className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition duration-300 text-sm sm:text-base"
                style={{borderColor: 'var(--border)', backgroundColor: 'var(--input)', color: 'var(--foreground)'}}
              ></textarea>
            </div>
            <button
              type="submit"
              className="w-full py-2.5 sm:py-3 px-6 bg-gradient-to-r from-blue-500 to-purple-600 text-white font-medium rounded-lg hover:opacity-90 active:opacity-80 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-300"
            >
              {t('common.cta.sendMessage')}
            </button>
          </form>
        </div>
      </div>
    </section >
  );
};

export default Contact;
